<template>
  <div class="program-page">
    <div v-for="(item, index) in programList" :key="index" class="item-div">
      <p class="item-title" v-html="item.title"></p>

      <div class="second img-left">
        <img :src="imageSrc(item.num)" alt="">
        <div class="desc-div">
          <p class="desc">{{item.desc}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LocalYellowWaveMain',
  data() {
    return {
      programList: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.programList = [
        {
          num: 1,
          title: '노란물결',
          desc: '“노란 물결”은 전남드래곤즈의 공식 응원가에서 착안한 지역사회연계활동 브랜드로 경기장을 채우는 응원의흐름처럼, 전남드래곤즈가 지역과 끊임없이 연결되는움직임을 의미한다.전남드래곤즈는 연고지 전남 곳곳을 찾아가 지역민과직접 호흡하며, 축제, 학교, 일상 속에서 함께하는다양한 지역사회연계활동을 이어가고 있다.'
        },
      ];
    },

    imageSrc(num) {
      return require(`@/assets/img/club/local_0${num}.png`);
    },
  },
};
</script>

<style scoped>
.total-year-records {
  padding-right: 0;
}

.total-year-records table {
  min-width: auto;
}

.program-page .item-div .desc {
  word-break: normal !important;
}

@media (max-width: 959px) {
  .total-year-records table {
    min-width: 800px;
  }
}
</style>
